import { makeStyles } from '@material-ui/core';
import { neutral } from '../../../../shared/styles/colors';

export default makeStyles(() => ({
  root: {
    alignItems: 'center',
    background: neutral.white,
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'flex-end',
  },
  editOrderButton: {
    color: neutral[100],
    textDecoration: 'underline',
  },
}));
